/* Höstkampanj: val av servicepaket och inlämningsdag, sedan direkt till kassan. */
var HK_ICONS = (function () {
  var o = '<svg viewBox="0 0 64 40" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">';
  var c = '</svg>';
  var bike = '<circle cx="50" cy="26" r="9"/><circle cx="14" cy="26" r="9"/>' +
    '<path d="M50 26 L34 26 L37 13 M50 26 L37 14 L19 14 M34 26 L18 15 M14 26 L20 11 M16 9 L23 9 M33 12 L41 12 M20 11 L22 7"/>';
  return {
    'hostkampanj-cykel': o + bike + c,
    'hostkampanj-elcykel': o + bike + '<path class="bolt" d="M49 1 L44.5 8 L48.5 8 L45.5 15 L52 6.5 L48 6.5 Z" fill="#f5c400" stroke="#f5c400" stroke-width="1"/>' + '<rect x="24" y="17" width="8" height="4" rx="1" transform="rotate(34 28 19)" fill="currentColor" stroke="none"/>' + c,
    'hostkampanj-ladcykel-2-hjul': o +
      '<circle cx="10" cy="32" r="5"/><circle cx="52" cy="27" r="8"/>' +
      '<rect x="8" y="14" width="20" height="12" rx="1.5"/>' +
      '<path d="M10 32 L14 28 L38 28 L52 27 M38 28 L36 13 L52 27 M32 12 L40 12 M31 27 L29 9 M26 9 L32 9"/>' + c,
    'hostkampanj-ladcykel-3-hjul': o +
      '<circle cx="9" cy="32" r="5"/><circle cx="17" cy="33" r="5"/><circle cx="52" cy="27" r="8"/>' +
      '<rect x="4" y="11" width="24" height="15" rx="1.5"/>' +
      '<path d="M28 28 L38 28 L52 27 M38 28 L36 13 L52 27 M32 12 L40 12 M31 26 L30 8 M27 8 L33 8"/>' + c,
    'hostkampanj-longtail': o +
      '<circle cx="12" cy="27" r="8"/><circle cx="52" cy="27" r="8"/>' +
      '<path d="M12 27 L18 11 M15 8 L21 8 M18 11 L17 8 M17 14 L31 14 M16 17 L29 27 M29 27 L52 27 M29 27 L32 13 M28 12 L36 12 M32 15 L52 27"/>' +
      '<path d="M35 18 L61 18 M44 18 L47 26 M58 18 L55 25" stroke-width="2.4"/>' + c
  };
})();

(function () {
  var el = document.getElementById('hk-data');
  if (!el) return;
  var data = JSON.parse(el.textContent);
  var YEAR = 2026, MONTH = 9; // oktober

  var dayNames = ['söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag'];
  var monthNames = ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'december'];
  var kr = function (ore) {
    var n = ore / 100;
    return n.toLocaleString('sv-SE', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }) + ' kr';
  };
  var fmt = function (d) { return dayNames[d.getDay()] + ' ' + d.getDate() + ' ' + monthNames[d.getMonth()]; };
  var short = function (d) { return dayNames[d.getDay()].slice(0, 3) + ' ' + d.getDate() + ' okt'; };
  var isWorkday = function (d) { var w = d.getDay(); return w !== 0 && w !== 6; };
  var isWeekend = function (d) { return !isWorkday(d); };
  var nextMonday = function (d) { var r = new Date(d); do { r.setDate(r.getDate() + 1); } while (r.getDay() !== 1); return r; };
  var addWorkdays = function (d, n) { var r = new Date(d); while (n > 0) { r.setDate(r.getDate() + 1); if (isWorkday(r)) n--; } return r; };

  // Beskrivningar styrs här, så att texten inte beror på produkttexten i Shopify.
  var NAME = { 'hostkampanj-elcykel': 'Elcykel/Rawbike' };
  var pname = function (p) { return NAME[p.handle] || p.name; };
  var DESC = {
      "hostkampanj-cykel": "Genomgång och justering av bromsar, växlar, styrlager, vevlager och kedja. Smörjning av rörliga delar och handtvätt.",
      "hostkampanj-elcykel": "Genomgång och justering av bromsar, växlar, styrlager, vevlager och kedja. Smörjning av rörliga delar och handtvätt. Genomgång av elsystemet.",
      "hostkampanj-ladcykel-2-hjul": "Genomgång och justering av bromsar, växlar, styrlager, vevlager och kedja. Smörjning av rörliga delar och handtvätt. Genomgång av elsystemet. För long john och andra tvåhjuliga lådcyklar.",
      "hostkampanj-ladcykel-3-hjul": "Genomgång och justering av bromsar, växlar, styrlager, vevlager och kedja. Smörjning av rörliga delar och handtvätt. Genomgång av elsystemet.",
      "hostkampanj-longtail": "Genomgång och justering av bromsar, växlar, styrlager, vevlager och kedja. Smörjning av rörliga delar och handtvätt. Genomgång av elsystemet om cykeln är elektrisk."
  };

  var state = { pkg: null, day: null };

  // Servicepaket
  var pkgs = document.getElementById('pkgs');
  if (!data.packages.length) {
    var e = document.createElement('p');
    e.className = 'empty';
    e.textContent = 'Servicepaketen är inte upplagda än.';
    pkgs.appendChild(e);
  }
  data.packages.forEach(function (p) {
    var l = document.createElement('label');
    l.className = 'pkg';
    l.innerHTML = '<input type="radio" name="pkg" id="pkg-' + p.id + '" value="' + p.id + '">' +
      (p.icon ? '<span class="icon"><img src="' + p.icon + '" alt="" width="240" height="131"></span>' : (HK_ICONS[p.handle] ? '<span class="icon">' + HK_ICONS[p.handle] + '</span>' : '')) +
      '<span class="name"></span><span class="price">' +
      (p.compareAt > p.price ? '<s>' + kr(p.compareAt) + '</s>' : '') + '<b>' + kr(p.price) + '</b></span>';
    l.querySelector('.name').textContent = pname(p);
    
    l.querySelector('input').addEventListener('change', function () { state.pkg = p; update(); });
    pkgs.appendChild(l);
  });

  // Kalender
  var byDate = {};
  data.days.forEach(function (d) { byDate[d.date] = d; });
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var grid = document.getElementById('grid');
  ['mån', 'tis', 'ons', 'tor', 'fre', 'lör', 'sön'].forEach(function (d) {
    var e = document.createElement('div'); e.className = 'dow'; e.textContent = d; grid.appendChild(e);
  });
  var lead = (new Date(YEAR, MONTH, 1).getDay() + 6) % 7;
  for (var i = 0; i < lead; i++) { var b = document.createElement('div'); b.className = 'blank'; grid.appendChild(b); }
  var today = new Date(); today.setHours(0, 0, 0, 0);
  var last = new Date(YEAR, MONTH + 1, 0).getDate();
  var buttons = [];
  for (var n = 1; n <= last; n++) {
    (function (n) {
      var d = new Date(YEAR, MONTH, n);
      // Helgdagar visar inga platser men bokas på måndagens platser.
      var weekend = isWeekend(d);
      var base = weekend ? nextMonday(d) : d;
      var slot = byDate[base.getFullYear() + '-' + pad(base.getMonth() + 1) + '-' + pad(base.getDate())];
      var closed = !slot || d < today;
      var full = !closed && slot.left <= 0;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'day';
      btn.setAttribute('aria-pressed', 'false');
      btn.innerHTML = n + (closed || (weekend && !full) ? '' : '<small>' + (full ? 'fullt' : slot.left + ' kvar') + '</small>');
      if (!closed && !full) btn.classList.add('open');
      if (!closed && !full && !weekend && slot.left === 1) btn.classList.add('last');
      btn.setAttribute('aria-label', fmt(d) + (closed ? ', stängt för inlämning' : full ? ', fullbokad' : weekend ? ', öppet för inlämning' : ', ' + slot.left + ' platser kvar'));
      if (closed || full) { btn.disabled = true; if (full) btn.classList.add('full'); }
      btn.addEventListener('click', function () {
        buttons.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        state.day = { date: d, base: base, weekend: weekend, slot: slot };
        update();
      });
      buttons.push(btn);
      grid.appendChild(btn);
    })(n);
  }

  var pickup = document.getElementById('pickup');
  var sum = document.getElementById('sum');
  var pay = document.getElementById('pay');
  var err = document.getElementById('err');

  // Kassaraden döljs medan första skärmen syns, så att den inte konkurrerar med knappen där.
  var bar = document.getElementById('bar');
  var hero = document.getElementById('hero');
  var heroVisible = true;
  function syncBar() { bar.classList.toggle('away', heroVisible && !state.pkg && !state.day); }
  if (hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) { heroVisible = e[0].intersectionRatio > 0.4; syncBar(); }, { threshold: [0, 0.4, 1] }).observe(hero);
  } else {
    heroVisible = false; syncBar();
  }

  function ready() {
    var a = addWorkdays(state.day.base, data.readyMin), b = addWorkdays(state.day.base, data.readyMax);
    return a.getTime() === b.getTime() ? fmt(a) : fmt(a) + ' eller ' + fmt(b);
  }

  function readyShort() {
    var a = addWorkdays(state.day.base, data.readyMin), b = addWorkdays(state.day.base, data.readyMax);
    return a.getTime() === b.getTime() ? short(a) : short(a) + ' eller ' + short(b);
  }

  function update() {
    if (state.day) {
      pickup.hidden = false;
      document.getElementById('pickupDate').textContent = ready();
      document.getElementById('pickupHours').textContent = 'Mellan 10 och 18. Vi hör av oss när cykeln är klar.';
    }
    sum.innerHTML = '';
    var b = document.createElement('b');
    var s = document.createElement('span'); s.className = 'muted';
    if (state.pkg && state.day) {
      b.textContent = pname(state.pkg) + ' · ' + kr(state.pkg.price);
      s.textContent = 'Lämnas in ' + short(state.day.date);
    } else {
      b.textContent = state.pkg ? 'Välj dag att lämna in' : state.day ? 'Välj cykel' : 'Välj cykel och dag';
      s.textContent = state.pkg ? pname(state.pkg) : state.day ? 'Lämnas in ' + short(state.day.date) : '10 % rabatt i oktober';
    }
    sum.appendChild(b); sum.appendChild(s);
    if (state.day) {
      var r = document.createElement('span'); r.className = 'ready';
      r.textContent = 'Klar att hämta ' + readyShort() + ', 10–18';
      sum.appendChild(r);
    }
    pay.disabled = !(state.pkg && state.day);
    if (pay2) pay2.textContent = state.pkg ? 'Betala och boka' : 'Välj cykel först';
    err.hidden = true;
    syncBar();
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      if (!r.ok) return r.json().catch(function () { return {}; }).then(function (j) { throw j; });
      return r.json();
    });
  }

  var pay2 = document.getElementById('pay2');
  var buttons2 = [pay, pay2];
  function setBusy(on) {
    buttons2.forEach(function (b) {
      if (!b) return;
      b.disabled = on;
      if (on) { b.setAttribute('aria-busy', 'true'); b.textContent = 'Går till kassan…'; }
      else { b.removeAttribute('aria-busy'); b.textContent = 'Betala och boka'; }
    });
  }

  function checkout() {
    if (!state.day) return;
    if (!state.pkg) {
      document.getElementById('boka').scrollIntoView({ behavior: 'smooth', block: 'start' });
      err.hidden = false;
      err.textContent = 'Välj vilken typ av cykel du har först.';
      return;
    }
    setBusy(true);
    var dropoff = fmt(state.day.date);
    post('/cart/clear.js')
      .then(function () {
        return post('/cart/add.js', {
          items: [
            { id: state.pkg.id, quantity: 1, properties: { 'Inlämning': dropoff, 'Klar att hämta': ready() } },
            state.day.weekend
              ? { id: state.day.slot.id, quantity: 1, properties: { 'Inlämning': dropoff + ' (helg, räknas på måndagens plats)' } }
              : { id: state.day.slot.id, quantity: 1 }
          ]
        });
      })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function (e) {
        setBusy(false);
        update();
        err.hidden = false;
        err.textContent = (e && e.status === 422)
          ? 'Den dagen blev precis fullbokad. Välj en annan dag.'
          : 'Något gick fel. Försök igen om en stund.';
      });
  }

  pay.addEventListener('click', checkout);
  if (pay2) pay2.addEventListener('click', checkout);

  // Checklistan stängs vid klick var som helst i den, inte bara på rubriken.
  var cl = document.querySelector('.checklist');
  if (cl) {
    cl.addEventListener('click', function (e) {
      if (!cl.open || e.target.closest('summary')) return;
      cl.open = false;
      var sm = cl.querySelector('summary');
      if (sm.getBoundingClientRect().top < 0) sm.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });
  }

  // Prickar under bildraden som visar var man är och att det går att svepa.
  var gal = document.querySelector('.gallery');
  var dotsEl = document.querySelector('.gallery-nav .dots');
  if (gal && dotsEl) {
    var items = gal.querySelectorAll('li');
    var dots = [];
    items.forEach(function (li, i) {
      var d = document.createElement('i');
      d.addEventListener('click', function () { gal.scrollTo({ left: li.offsetLeft - gal.offsetLeft, behavior: 'smooth' }); });
      dotsEl.appendChild(d); dots.push(d);
    });
    var mark = function () {
      var max = gal.scrollWidth - gal.clientWidth;
      var i = max <= 0 ? 0 : Math.round((gal.scrollLeft / max) * (items.length - 1));
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
    };
    gal.addEventListener('scroll', mark, { passive: true });
    mark();
  }
})();
